import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import dataTableGrid from "../DataTableGrid";
import {
  getParticipansList,
  deleteDataMultipleCondition,
} from "../../Utils/adminFunctions";

let AdminListParticipants = () => {
  const [listParticipants, setListParticipants] = useState([]);
  const { pgID } = useParams();
  useEffect(() => {
    manageParticipants();
  }, []);
  const manageParticipants = async () => {
    let bodyFormData = new FormData();
    bodyFormData.append("participant_group_id", pgID);
    const response = await getParticipansList(bodyFormData);
    if (response.status === "success" || response.status === "failure") {
      setListParticipants(response.optionItems);
      dataTableGrid({
        data_table_id: "#participants_list",
        paginate: false,
        copy_option: [0, 1, 2, 3, 4, 5, 6],
        csv_option: [0, 1, 2, 3, 4, 5, 6],
        print_option: [0, 1, 2, 3, 4, 5, 6],
        sort_option: [7],
      });
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };
  const handleDeleteRecord = async () => {
    let pID = document.getElementById("deleteParticipant").value;
    const response = await deleteDataMultipleCondition(
      pID,
      pgID,
      "PARTICIPANT"
    );
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
      manageParticipants();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    }
  };
  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="modal fade show" id="modal-default" arial-modal="true">
        <input type="hidden" id="deleteParticipant" value=""></input>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm delete</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleDeleteRecord()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title pull-right ">
                          <Link
                            to={"/AdminAddParticipantsAssing/" + pgID}
                            className="btn btn-sm custom-btn-primary"
                          >
                            <i className="fa fa-plus"></i> Add Participants
                          </Link>{" "}
                          <Link
                            to={"/AdminAddParticipant/" + pgID}
                            className="btn btn-sm custom-btn-primary"
                          >
                            <i className="fa fa-plus"></i> Add Participant
                          </Link>{" "}
                          <Link
                            to="/AdminListParticipantGroups"
                            className="btn btn-sm custom-btn-primary"
                          >
                            <i className="fa fa-arrow-left"></i> Back
                          </Link>
                        </h3>
                      </div>
                      <div className="card-body">
                        <table
                          id="participants_list"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Participant Name</th>
                              <th>Profession</th>
                              <th>Country</th>
                              <th>Email</th>
                              <th>Contact No.</th>
                              <th>Created On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{listParticipants}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListParticipants;
